import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sidebar-container',
  templateUrl: './sidebar-container.component.html',
  styleUrls: ['./sidebar-container.component.scss']
})
export class SidebarContainerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
